module.exports = __webpack_public_path__ + "static/PFB__0003_Chart-e815215b1b490d29aa128daa06c6cc6c.png";